<template>
<div class="chapter">
<div class="inner_page">
<p class="chimage"><img alt="image" src="images/pxiii.png"/></p>
<p class="indent-top">Tanya Brockett, Editor &amp; Publishing Mentor—Much gratitude for your encouragement and support throughout this journey. I appreciate your expertise, your commitment, and your persistence. You always believed in me and knew that this book would one day inspire many others to persevere through their challenges. Thank you.</p>
<p class="indent">Morgan James Publishing—What a gift to have been introduced to and to work with a highly competent and equally lovely group of individuals. A special thank you to David Hancock (Morgan James CEO and founder), Jim Howard, Aubrey Kosa, Bonnie Rauch, and Terry Whalin for your professionalism and support through the process.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm05.vue?e3c43664